import { useContext, useEffect, useState } from 'react';
import { viewTypeList, scaleList, timePeriodList, deathTypeList, measurmentTypeList } from './store/StaticVariables';
import { InterfaceContext } from './store/InterfaceProvider';
import SearchField from './components/SearchField';

const arrayAsOptionList = (list) => {
    return list.map((item) => {
        return (
            <option key={item.id} value={item.slug}>
                {item.indent && <>&nbsp;&nbsp;&nbsp;</>}
                {item.label}
            </option>
        );
    });
};
const ScaleButtonList = () => {
    const { activeViewType, activeScale, mapReadOnlyZoom, setActiveScale } = useContext(InterfaceContext);
    const filterListByViewType = () => {
        let cloned = [...scaleList];
        if (activeViewType === 'deaths') {
            return cloned.slice(0, 3);
        } else {
            return cloned.slice(0, 2).concat(scaleList[3]);
        }
    };
    const [list, setList] = useState(() => filterListByViewType());

    useEffect(() => {
        setList(filterListByViewType());
    }, [activeViewType]);

    return list.map((item) => {
        const disabled = item.minZoom > mapReadOnlyZoom;
        return (
            <div className={'control'} key={item.id} aria-disabled={disabled}>
                <div className="control-wrap">
                    <button className={'no-select' + (activeScale === item.slug ? ' active' : '')} value={item.slug} onClick={(evt) => setActiveScale(evt.target.value)}>
                        {item.label}
                    </button>
                </div>
            </div>
        );
    });
};

const ScaleRadioButtonList = () => {
    const { activeViewType, activeScale, activeTimePeriod, mapReadOnlyZoom, setActiveScale } = useContext(InterfaceContext);
    const filterListByViewType = () => {
        let cloned = [...scaleList];
        if (activeViewType === 'deaths') {
            return cloned.slice(0, 3);
        } else {
            return cloned.slice(0, 2).concat(scaleList[3]);
        }
    };
    const [list, setList] = useState(() => filterListByViewType());

    useEffect(() => {
        setList(filterListByViewType());
    }, [activeViewType]);

    return list.map((item) => {
        const withinZoomRequirment = item.minZoom <= mapReadOnlyZoom;
        const withinYearRequirment = item.years === '*' || item.years.split(',').indexOf(activeTimePeriod) !== -1;
        // const disabled = !withinZoomRequirment || !withinYearRequirment;
        const disabled = !withinYearRequirment;
        return (
            <div className={'control'} key={item.id} aria-disabled={disabled}>
                <div className="control-wrap">
                    <input id={'scale-' + item.id} className="no-select" type="radio" name="scale" value={item.slug} disabled={disabled} checked={activeScale === item.slug} onClick={(evt) => setActiveScale(evt.target.value)} onChange={() => {}} />
                    <label htmlFor={'scale-' + item.id}>{item.label}</label>
                    {!disabled && !withinZoomRequirment && <span className="unavailable-text">(Zoom in to view)</span>}
                    {disabled && <span className="unavailable-text">(Not available for this time period)</span>}
                </div>
            </div>
        );
    });
};

const UIControls = () => {
    const { activeViewType, activeTimePeriod, activeDeathType, activeMeasurement } = useContext(InterfaceContext);
    const { setActiveViewType, setActiveTimePeriod, setActiveDeathType, setActiveMeasurement } = useContext(InterfaceContext);
    const [adjMeasurmentTypeList, setAdjMeasurementTypeList] = useState(measurmentTypeList);
    const [adjTimePeriodList, setAdjTimePeriodList] = useState(timePeriodList);

    useEffect(() => {
        setAdjMeasurementTypeList(measurmentTypeList.filter((item) => item.view === activeViewType));
        let cloned = [...timePeriodList];
        if (activeViewType !== 'deaths') {
            cloned = cloned.slice(0, 3);
        }
        setAdjTimePeriodList(cloned);
    }, [activeViewType]);

    return (
        <div id="dashboard-controls" aria-label="Map and Data filters" role="toolbar">
            <div id="dash-top-line" className="dashboard-row-flex">
                <div className="search-wrap">
                    <SearchField />
                </div>
            </div>
            <div id="dash-dropdowns" className="dashboard-row-flex">
                <div id="view" className="control">
                    <div className="control-wrap">
                        <label htmlFor="view-select" className="no-select">
                            View
                        </label>
                        <select id="view-select" className="field no-select" aria-disabled={true} value={activeViewType} onChange={(evt) => setActiveViewType(evt.target.value)}>
                            {arrayAsOptionList(viewTypeList)}
                        </select>
                    </div>
                </div>
                {activeViewType === 'deaths' && (
                    <div id="type" className="control">
                        <div className="control-wrap">
                            <label htmlFor="death-type-select" className="no-select">
                                Type
                            </label>
                            <select id="death-type-select" className="field no-select" value={activeDeathType} onChange={(evt) => setActiveDeathType(evt.target.value)}>
                                {arrayAsOptionList(deathTypeList)}
                            </select>
                        </div>
                    </div>
                )}
                {activeViewType !== 'deaths' && (
                    <div id="type" className="control">
                        <div className="control-wrap">
                            <label htmlFor="death-type-select" className="no-select">
                                Type
                            </label>
                            <select id="death-type-select" className="field no-select" aria-disabled="true">
                                <option>All Firearm Injury ED Visits</option>
                            </select>
                        </div>
                    </div>
                )}
                <div id="time" className="control">
                    <div className="control-wrap">
                        <label htmlFor="time-period-select" className="no-select">
                            Time Period
                        </label>
                        <select id="time-period-select" className="field no-select" value={activeTimePeriod} onChange={(evt) => setActiveTimePeriod(evt.target.value)}>
                            {arrayAsOptionList(adjTimePeriodList)}
                        </select>
                    </div>
                </div>
                <div id="measure" className={'control'}>
                    <div className="control-wrap">
                        <label htmlFor="measure-select" className="no-select">
                            Measure
                        </label>
                        <select id="measure-select" className="field no-select" aria-disabled={activeViewType !== 'deaths'} value={activeMeasurement} onChange={(evt) => setActiveMeasurement(evt.target.value)}>
                            {arrayAsOptionList(adjMeasurmentTypeList)}
                        </select>
                    </div>
                </div>
            </div>
            {/* <div id="scale-buttons" className="dashboard-row-flex">
                <ScaleButtonList />
            </div> */}
            <div id="scale-radio-buttons" className="dashboard-row-flex">
                <ScaleRadioButtonList />
            </div>
        </div>
    );
};
export default UIControls;
